import {  select, selectAll } from 'd3-selection';
import line from 'britecharts/dist/umd/line.min';
import miniTooltip from 'britecharts/dist/umd/tooltip.min';
import 'britecharts/dist/css/britecharts.min.css';
import _ from 'lodash';

class HomeController {
  /*@ngInject*/
  constructor(Auth, $state, ConfigService, UserService, DateUtil, User, SetupService, RouteService, ShipmentService, BypassCodeService, $translate, $location, $q, Modal, HoldService, HoldLocationService, $scope, HomeService, LogService, DailyStatService, $rootScope, RouteDetailService, $filter) {
    this.Auth = Auth;
    this.$state = $state;
    this.$config = ConfigService;
    this.UserService = UserService;
    this.User = User;
    this.SetupService = SetupService;
    this.RouteService = RouteService;
    this.ShipmentService = ShipmentService;
    this.BypassCodeService = BypassCodeService;
    this.$translate = $translate;
    this.$location = $location;
    this.$q = $q;
    this.Modal = Modal;
    this.HoldService = HoldService;
    this.HoldLocationService = HoldLocationService;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.DateUtil = DateUtil;
    this.HomeService = HomeService;
    this.logService = LogService;
    this.entryTypes = [];
    this.logs = [];
    this.DailyStatService = DailyStatService;
    this.RouteDetailService = RouteDetailService;
    this.model = {
      branch: '',
      loggedInUserId: User.getUser().id
    }
    this.loading = true;
    this.aclPermission = {};
    this.model.branch = this.User.getUser().branchId;

    this.dailtStats = [];
    this.totalChartKeys = [];
    this.graphItems = [];
    this.tabShow = 'numbers';
    this.previousDays = {};
    this.datePopupIsOpened = false;
    this.dailtStatsDataOrNot = false;
    this.vaultDate = "";
    this.dashboardCount = [];
    this.$filter = $filter;
    this.pendingFilesToDownload = [];
    this.routeProgressDetails = [];
  }

  $onInit() {
    this.$config.getConfig().then(cfg => this.applicationVersion = cfg.config.version);
    this.loading = true;
    this.moment = moment;
    this.recentActivities();
    this.loadAclPermission();
    this.SetupService.get(this.model.branch)
      .then((data) => {
        this.vaultDate = this.DateUtil.convertToDate(data.currentVaultDate || undefined);
        this.currentVaultDate = this.DateUtil.convertToDate(data.currentVaultDate || undefined);
        this.getDashboardData();
        this.getYesterdayData();
        this.getRouteDetailsData();
        this.loading = false;
        this.options = {
          maxDate: this.vaultDate,
          showWeeks: true
        };
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal('error.' + err.data.message)
        }
      });
    this.$rootScope.$broadcast('routeChange', '/app/home');
  }

  dashboarShow(tabName) {
    this.tabShow = tabName;
    if (this.tabShow == 'chart' && !_.hasIn(this.dailtStats, 'bagoutCount')) {
      this.clearChart();
      this.loadGraphData()
    }
  }

  getTotalChartKeys() {
    return [{
        key: 'checkInCount',
        label: this.$translate.instant('dashboard.check_in'),
        aclPermission: angular.isDefined(this.aclPermission.check_in),
        maxRatio: 2
      },
      {
        key: 'checkOutCount',
        label: this.$translate.instant('dashboard.check_out'),
        aclPermission: angular.isDefined(this.aclPermission.check_out),
        maxRatio: 2
      },
      {
        key: 'checkInTotalAmount',
        label: this.$translate.instant('dashboard.check_in_amount'),
        aclPermission: angular.isDefined(this.aclPermission.check_in),
        maxRatio: 2
      },
      {
        key: 'checkOutTotalAmount',
        label: this.$translate.instant('dashboard.check_out_amount'),
        aclPermission: angular.isDefined(this.aclPermission.check_out),
        maxRatio: 2
      },
      {
        key: 'holdCount',
        label: this.$translate.instant('dashboard.shipment_hold'),
        aclPermission: angular.isDefined(this.aclPermission.branch_mgmt_item_holds),
        maxRatio: 2
      },
      {
        key: 'holdLocationCount',
        label: this.$translate.instant('dashboard.location_hold'),
        aclPermission: angular.isDefined(this.aclPermission.branch_mgmt_location_holds),
        maxRatio: 2
      },
      {
        key: 'byPassCodeCount',
        label: this.$translate.instant('dashboard.bypasscode_used'),
        aclPermission: angular.isDefined(this.aclPermission.branch_mgmt_bypass_code),
        maxRatio: 2
      },
      {
        key: 'bagoutCount',
        label: this.$translate.instant('dashboard.bag_out'),
        aclPermission: angular.isDefined(this.aclPermission.bag_out),
        maxRatio: 2
      },
      {
        key: 'activeAppUsers',
        label: this.$translate.instant('dashboard.active_app_users'),
        aclPermission: angular.isDefined(this.aclPermission['setting-users']),
        maxRatio: 2
      },
      {
        key: 'serviceTickets',
        label: this.$translate.instant('navbar.serviceTickets_title'),
        aclPermission: angular.isDefined(this.aclPermission['service_tickets']),
        maxRatio: 2
      },
      {
        key: 'routeRunTime',
        label: this.$translate.instant('dashboard.route_run_time'),
        aclPermission: angular.isDefined(this.aclPermission['route_control']),
        maxRatio: 2
      },
      {
        key: 'countedResidualsAmount',
        label: this.$translate.instant('branch_mgmt.daily_balance_sheet.actualResidual'),
        aclPermission: angular.isDefined(this.aclPermission.atm_count),
        maxRatio: 2
      },
      {
        key: 'cashDepositedAmount',
        label: this.$translate.instant('dashboard.total_cash_deposited'),
        aclPermission: angular.isDefined(this.aclPermission.atm_count),
        maxRatio: 2
      },
    ];

  }

  loadAclPermission() {
    this.UserService.acl(this.User.getUser().id, this.model.branch).then((permissions) => {
      this.aclPermission = permissions;
    }).catch(e => console.log('error in permission', e));
  }

  loadGraphData() {
    this.dailtStatsDataOrNot = false;
    this.graphItems = this.getTotalChartKeys();
    let endDate = this.moment.utc(this.vaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    let startDate = moment.utc(moment.utc(endDate).subtract(6, 'days')).startOf('day').format('YYYY-MM-DD HH:mm:ss');
    let grediantColor = [
      '#41cfea','#6AEDC7', '#41cfea','#6AEDC7', '#41cfea','#6AEDC7',
      '#ffb11b','#f3c51c', '#ffb11b','#f3c51c', '#ffb11b','#f3c51c',
      '#fd9e62', '#ffa71a','#fd9e62', '#ffa71a','#fd9e62', '#ffa71a'
    ]
    setTimeout(() => {
      this.graphItems.forEach((obj, index) => {
        if (obj.aclPermission) {
          let selector = '.js-loading-container-' + obj.key;
          let lineChart = line(),
            lineContainer = select(selector),
            containerWidth = lineContainer.node() ? lineContainer.node().getBoundingClientRect().width : false;
          if (containerWidth) {
            lineContainer.html(lineChart.loadingState())
          }
        }
      })
    }, 100);

    this.DailyStatService.getDailyStats(startDate, endDate, this.model.branch)
      .then(res => {
        let chartArray = {};
        this.dailtStatsRecord = res;
        if (!res.length) {
          setTimeout(() => {
            this.graphItems.forEach((obj, index) => {
              if (obj.aclPermission) {
                let selectorLoading = '.js-loading-container-' + obj.key;
                $(selectorLoading).empty();
                this.dailtStatsDataOrNot = true;
              }
            })
          }, 500);
        }

        if (res.length) {
          //create dataset object 
          res.forEach((item, index) => {
            let dataObj = item.data;
            this.graphItems.forEach((obj, index) => {
              if (obj.aclPermission) {
                if (chartArray[obj.key] && chartArray[obj.key].dataset) {
                  chartArray[obj.key]['dataset'].dataByTopic[0].dates.push({
                    date: this.moment.utc(item.date).format('DD-MMM-YYYY'),
                    value: dataObj[obj.key] || 0,
                    fullDate: this.moment.utc(item.date).format()
                  })
                } else {
                  chartArray[obj.key] = {
                    dataset: {}
                  }
                  chartArray[obj.key].dataset = {
                    dataByTopic: [{
                      topic: obj.key,
                      topicName: obj.label,
                      branch: item.branchId,
                      dates: [{
                        date: this.moment.utc(item.date).format('DD-MMM-YYYY'),
                        value: dataObj[obj.key] || 0,
                        fullDate: this.moment.utc(item.date).format()
                      }]
                    }]
                  }
                  if (obj.key.indexOf('Amount') >= 0) {
                    chartArray[obj.key].dataset.dataByTopic[0].topicName = (obj.label).replace(obj.label, 'Amount');
                  }
                }
              }
            })
          });
          this.dailtStats = chartArray;
          let i = 0;
          this.graphItems.forEach((obj, index) => {
            if (obj.aclPermission) {
              let selector = '.js-line-chart-container-' + obj.key;
              let selectorLoading = '.js-loading-container-' + obj.key;
              let lineChart = line(),
                chartTooltip = miniTooltip(),
                lineContainer = select(selector),
                containerWidth = lineContainer.node() ? lineContainer.node().getBoundingClientRect().width : false,
                tooltipContainer,
                dataset;
                                
              if (containerWidth) {
                dataset = chartArray[obj.key].dataset;
                setTimeout(() => {
                  $(selectorLoading).empty();
                  lineChart
                    .lineGradient([grediantColor[i], grediantColor[i+1]])
                    .colorSchema([grediantColor[i+1]])
                    .isAnimated(false)
                    .aspectRatio(0.7)
                    .height(200)
                    .tooltipThreshold(0)
                    .grid('horizontal')
                    .lineCurve('catmullRom')
                    .width(containerWidth)
                    .margin({left: 50,right: 20,top: 20,bottom: 50})
                    .xTicks(2)
                    .dateLabel('date')
                    .valueLabel('value')
                    .on('customMouseOver', chartTooltip.show)
                    .on('customMouseMove', function (dataPoint, topicColorMap, x) {
                      chartTooltip.update(dataPoint, topicColorMap, 66);
                    })
                    .on('customMouseOut', chartTooltip.hide);

                  lineContainer.datum(dataset).call(lineChart);

                  tooltipContainer = select(`${selector} .line-chart .metadata-group`);
                  chartTooltip.title(obj.label);
                  if (obj.key.indexOf('Amount') >= 0) {
                    chartTooltip
                      .valueFormatter(value => this.$filter('currency')(value, '$', 2));
                  }
                  tooltipContainer.datum([]).call(chartTooltip);

                  const redrawChart = () => {
                    let container = select(selector);
                    let newContainerWidth = container.node() ? container.node().getBoundingClientRect().width : false;
                    // Setting the new width on the chart
                    lineChart.width(newContainerWidth);
                    // Rendering the chart again
                    container.datum(dataset).call(lineChart);
                  };
                  const throttledRedraw = _.throttle(redrawChart, 200);
                  window.addEventListener("resize", throttledRedraw);
                  i+=2
                }, 1000);
                this.loading = false;
              }
            }
          })
        }
      })
  }

  // Load dashboard statistics
  getDashboardData() {
    if (moment(this.vaultDate).isSame(this.currentVaultDate, 'day')) {
      this.HomeService.dashboard(moment(this.vaultDate).format('YYYY-MM-DD'), this.model.branch, this.model.loggedInUserId)
        .then((data) => {
          this.uploadedFileList = data.batchFiles;
          // this.pendingFilesToDownload = data.pendingFilesToDownload || [];
          this.routeProgressDetails = data.routesInProgress || [];
          this.dashboardCount = this.getTotalChartKeys();
          this.dashboardCount.forEach((obj, index) => {
            obj.hasCurrency = false;
            obj.itemCount = data[obj.key] || 0;
            if ((obj.key).indexOf('Amount') >= 0) {
              obj.hasCurrency = true;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      let endDate = moment(this.vaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      let startDate = moment.utc(endDate).startOf('day').format('YYYY-MM-DD 00:00:00');
      let data;

      this.DailyStatService.getDailyStats(startDate, endDate, this.model.branch).then(dailyStats =>
        this.HomeService.branchStats(this.model.branch, startDate, endDate, this.model.loggedInUserId).then((branchStats) => [dailyStats, branchStats]))
        .then(([dailyStats, branchStats]) => {
          // let data = dailyStats.length && dailyStats[0].data ? dailyStats[0].data : {};
          const keys = Object.keys(branchStats.results);

          keys.forEach(key => {
            data = Object.assign(dailyStats.length ? dailyStats[0].data : {}, 
                   { [key]: branchStats.results[key] && branchStats.results[key][0] ? branchStats.results[key][0] : 
                            branchStats.results[key] !== null ? branchStats.results[key] : 0 });
          })

          this.dashboardCount = this.getTotalChartKeys();
          this.dashboardCount.forEach((obj, index) => {
            data[obj.key] = data[obj.key] && data[obj.key].length === 0 ? 0 : data[obj.key]
            obj.hasCurrency = false;
            obj.itemCount = data[obj.key] || 0;
            if ((obj.key).indexOf('Amount') >= 0) {
              obj.hasCurrency = true;
            }
          });
        });
    }
  }

  getYesterdayData() {
    let endDate = moment(this.vaultDate).subtract(1, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
    let startDate = moment.utc(moment.utc(endDate)).startOf('day').format('YYYY-MM-DD HH:mm:ss');
    let keys = this.getTotalChartKeys();
    this.DailyStatService.getDailyStats(startDate, endDate, this.model.branch).then(res => {
        if (res.length && res[0].data) {
          // let data = JSON.parse(res[0].data);
          let data = res[0].data
          keys.forEach((obj) => {
            this.previousDays[obj.key] = data[obj.key] || 0
          })
        } else {
          keys.forEach((obj) => {
            this.previousDays[obj.key] = 0
          })
        }
        this.loading = false;
      })
      .catch((err) => {
        console.log(err);
        keys.forEach((obj) => {
          this.previousDays[obj.key] = 0
        })
      });
  }

  recentActivities() {
    this.model.gettingRecentLogs = true;
    this.logService.recentActivity(this.model.branch, this.entryType)
      .then((data) => {
        this.logs = data.results;
        if (this.logs.length) {
          this.logs.forEach((log) => {
            log.readableEntryType = this.$translate.instant('entry_type.' + log.entryType)
            if (log.entryData) {
              log.extraDetails = Object.entries(log.entryData).map((entry) => {
                return {
                  key: entry[0],
                  value: typeof entry[1] === 'object' ? JSON.stringify(entry[1]) : entry[1]
                };
              });
            }
          });
          this.entryTypes = data.entryTypes.map((entryType) => {
            return {
              label: this.$translate.instant('entry_type.' + entryType),
              value: entryType
            };
          });
        }
      })
      .catch((err) => {
        this.error = err.message
      })
      .finally(() => {
        this.model.gettingRecentLogs = false;
      })
  }

  toggleExpand(log) {
    log.expand = !log.expand;
  }

  isDateChanged = function (currentDate, mode) {
    this.loading = true;
    this.vaultDate = currentDate;
    this.dailtStats = [];
    this.getDashboardData();
    this.getYesterdayData();
    if (this.tabShow == 'numbers') {
      this.dashboarShow('numbers');
    } else if (this.tabShow == 'chart') {
      this.dashboarShow('chart');
    }
  }

  openDatePicker = function () {
    this.datePopupIsOpened = true;
  }

  clearChart = function () {
    this.graphItems.forEach((obj, index) => {
      if (obj.aclPermission) {
        let selector = '.js-line-chart-container-' + obj.key;
        let selectorLoading = '.js-loading-container-' + obj.key;
        $(selector).empty();
        $(selectorLoading).empty();
      }
    })
  }

  getRouteDetailsData = function () {
    const routeSearchObj = {
      queryJSON: {
        rules: [{
            field: "branchId",
            condition: "=",
            data: this.model.branch
          },
          {
            field: "routeDate",
            condition: "=",
            data: moment(this.currentVaultDate).format("YYYY-MM-DD")
          },
        ],
        operator: 'AND',
      }
    }

    this.RouteDetailService.all(routeSearchObj, 0, 1000)
      .then((routeDetails) => {
        let routeSchedule = [];
        routeDetails.results.forEach((routeData) => {
          routeSchedule.push({
            routeId: routeData.routeId,
            routeDate: this.moment.utc(routeData.routeDate).format('YYYY-MM-DD')
          })
        })
        this.routeSchedule = routeSchedule;
      })
      .catch((err) => {
        this.loading = false;
      })
  }
}

export default HomeController;


// WEBPACK FOOTER //
// ./client/app/components/home/home.controller.js